export class maintenance{
    constructor(
        public VID? : any, 
        public client? : string,
        public contract? : string,
        public contract_name? : string,
        public VulRecordStatus? : string,
        public Validate? : any,

        public ClientDD?:any,
        public ContractDD?:any,
        public ContnameDD?:any,
        public CVEDD?:any,
        ){}
}